// extracted by mini-css-extract-plugin
export default {"menu":"index_menu_d7yqt","menu_w1000":"index_menu_w1000_l1Gox","logo":"index_logo_5YPhY","menu_r":"index_menu_r_s7q0p","active":"index_active_NWAB8"};